import DOMPurify from 'dompurify';

// 指導案(原案挿入設定 / DefaultPhrase)専用。指導案が出力するタグだけに絞る。
// class と data-*(data-type / data-rel_kind 等)は参照ロジック($(elem).data() / class="reference" 判定)が
// 依存するため保持必須。
// - class: ALLOWED_ATTR で明示的に許可。
// - data-*: ALLOWED_ATTR ではなく ALLOW_DATA_ATTR(DOMPurify デフォルト true)で許可される。
//   デフォルト任せだと「ALLOWED_ATTR に無い＝除去される」と誤読され誤って削除される恐れがあるため、
//   参照ロジックが data-* に依存することを明示する目的で true を明記する。
// on* / style 等の危険・不要属性は上記いずれにも該当しないため引き続き除去される。
export function sanitizeDefaultPhraseHtml(content: string): string {
  return DOMPurify.sanitize(content, {
    ALLOWED_TAGS: ['div', 'br', 'span'],
    ALLOWED_ATTR: ['class'],
    ALLOW_DATA_ATTR: true,
  });
}
